export const sort = (a?: string, b?: string) => {
  const first = a || '';
  const second = b || '';
  return first.localeCompare(second);
};
